import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { acquisitionsApi } from '../../lib/api';
import { DataTable } from '../../components/ui/DataTable';
import { formatDate, formatDutyStatus } from '../../lib/utils';
import { useAuth } from '../../hooks/useAuth';
const columns = [
    {
        key: 'wine',
        header: 'Wine',
        render: (row) => (_jsxs("div", { children: [_jsx("p", { className: "font-medium text-gray-900", children: row.wineName }), _jsxs("p", { className: "text-xs text-gray-500", children: [row.producerName, row.vintage ? ` · ${row.vintage}` : ''] })] })),
    },
    {
        key: 'date',
        header: 'Purchase Date',
        render: (row) => formatDate(row.purchaseDate),
        className: 'w-32 text-gray-600',
    },
    {
        key: 'merchant',
        header: 'Merchant',
        render: (row) => row.merchantName ?? row.purchaseSource,
        className: 'text-gray-600',
    },
    {
        key: 'bottles',
        header: 'Bottles',
        render: (row) => _jsx("span", { className: "tabular-nums font-medium", children: row.totalBottles }),
        className: 'w-20 text-right',
        headerClassName: 'text-right',
    },
    {
        key: 'duty',
        header: 'Duty',
        render: (row) => formatDutyStatus(row.dutyStatus),
        className: 'text-gray-500',
    },
    {
        key: 'arrival',
        header: 'Arrival',
        render: (row) => {
            if (row.actualArrivalDate) {
                return (_jsxs("span", { className: "badge bg-green-100 text-green-700", children: ["Arrived ", formatDate(row.actualArrivalDate)] }));
            }
            if (row.estimatedArrivalDate) {
                return (_jsxs("span", { className: "text-xs text-gray-500", children: ["Est. ", formatDate(row.estimatedArrivalDate)] }));
            }
            return _jsx("span", { className: "badge bg-yellow-100 text-yellow-700", children: "Pending" });
        },
    },
];
export function AcquisitionListPage() {
    const navigate = useNavigate();
    const { activeAccount, canEdit } = useAuth();
    const { data, isLoading } = useQuery({
        queryKey: ['acquisitions', activeAccount?.id],
        queryFn: acquisitionsApi.list,
        enabled: Boolean(activeAccount),
    });
    return (_jsxs("div", { className: "space-y-4", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsxs("div", { children: [_jsx("h1", { className: "page-title", children: "Acquisitions" }), _jsxs("p", { className: "text-sm text-gray-500 mt-0.5", children: [data?.lots?.length ?? 0, " lots"] })] }), canEdit && (_jsxs("button", { onClick: () => navigate('/acquisitions/new'), className: "btn-primary", children: [_jsx(Plus, { className: "h-4 w-4" }), "New acquisition"] }))] }), _jsx("div", { className: "card overflow-hidden", children: _jsx(DataTable, { columns: columns, data: data?.lots ?? [], isLoading: isLoading, rowKey: (row) => row.id, onRowClick: (row) => navigate(`/acquisitions/${row.id}`), emptyTitle: "No acquisitions", emptyDescription: "Record your first wine purchase to start building your cellar" }) })] }));
}
